export const isInIframe = (): boolean => {
  try {
    return globalThis.self !== window.top;
  } catch {
    return true;
  }
};
